import { connect } from 'react-redux';
import { withRouter, WithRouterProps } from 'react-router';
import { compose } from 'recompose';

import { withIntl, IntlProps } from 'ha/i18n';
import { Actions as NavbarActions } from 'ha/modules/NavBar/actions';
import { getIsAuthenticated } from 'ha/modules/AuthLogic/selectors';
import { GlobalState } from 'ha/types/store';
import { UpsertSearchAlertParams } from 'ha/services/apiV2/types/SearchAlert';

import {
  getCurrentSearchAlert,
  isSearchAlertDisabled,
  getSearchAlertParams,
} from '../../selectors';
import SearchAlertButton, {
  Props,
} from '../../components/SearchAlerts/SearchAlertButton';

interface StateProps {
  hasAlert: boolean;
  isDisabled: boolean;
  isAuthenticated: boolean;
  searchAlert?: UpsertSearchAlertParams;
}

interface OwnProps extends IntlProps, WithRouterProps {
  isMobile?: boolean;
  onClick?: (e: React.MouseEvent) => void;
}

interface DispatchProps {
  showAuthModal: (type: string, returnUrl: string, options: object) => void;
}

export type OuterProps = Pick<Props, 'color' | 'variant'>;

interface MergedProps extends IntlProps {
  hasAlert: boolean;
  isDisabled: boolean;
  onClick?: (options?: object) => void;
}

export default compose<OwnProps, OuterProps>(
  withIntl,
  withRouter,
  connect<StateProps, DispatchProps, OwnProps, MergedProps>(
    (state: GlobalState): StateProps => ({
      hasAlert: Boolean(getCurrentSearchAlert(state)),
      isDisabled: isSearchAlertDisabled(state),
      isAuthenticated: getIsAuthenticated(state),
      searchAlert: getSearchAlertParams(state) as UpsertSearchAlertParams,
    }),
    { showAuthModal: NavbarActions.showModal },
    (
      stateProps: StateProps,
      dispatchProps: DispatchProps,
      ownProps: OwnProps,
    ) => ({
      ...ownProps,
      hasAlert: stateProps.hasAlert,
      isDisabled: stateProps.isDisabled,
      getDynamicData: () => ({
        isLoggedIn: stateProps.isAuthenticated,
        hasAlert: stateProps.hasAlert,
      }),
      onClick: stateProps.isAuthenticated
        ? ownProps.onClick
        : (options?: object) =>
            dispatchProps.showAuthModal(
              'register',
              ownProps.intl.urlResolver.getCreateSearchAlertUrl(
                JSON.stringify(stateProps.searchAlert),
                `${ownProps.location.pathname}${ownProps.location.search}`,
              ),
              options || {},
            ),
    }),
  ),
)(SearchAlertButton);
